/* eslint-disable import/prefer-default-export */
import { useInfiniteQuery } from '@tanstack/react-query';

import {
  type RoleListRequestBody,
  type RoleListResponse,
  RolesService,
} from '../services/RolesService';

/**
 * Hook to fetch paginated and filtered list of roles with infinite scrolling support
 * Uses React Query's useInfiniteQuery for automatic pagination management
 * @param requestBody - Request body with filters (pagination is handled automatically)
 * @param pageSize - Number of items to fetch per page (defaults to 5)
 * @returns React Query infinite result with roles list data across all pages
 */
export const useInfiniteRoles = (
  requestBody: Omit<RoleListRequestBody, 'pagination'> = {},
  pageSize = 5
) =>
  useInfiniteQuery({
    // include pageSize in query key so different page sizes create separate cache entries
    queryKey: ['roles-infinite', requestBody, pageSize],
    queryFn: ({ pageParam = 1 }: { pageParam?: number }) =>
      RolesService.getRolesList({
        ...requestBody,
        pagination: { max: pageSize, page: pageParam },
      }),
    getNextPageParam: (lastPage: RoleListResponse) =>
      lastPage.pagination.nextPage,
    initialPageParam: 1,
    retry: 1,
  });
